<template>
    <v-card flat>
        <v-card-title>
            RESULTADOS
        </v-card-title>
        <v-divider/>
        <v-card-text>
            <Search @search="params = $event" :loading="loading" class="mb-3"/>
            <v-card outlined elevation="4">
                <v-card-title class="d-flex justify-space-between">
                    <v-btn color="secondary" @click="openResultadoModal()" small tile><v-icon>mdi-account-box</v-icon> AÑADIR RESULTADO</v-btn>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <template v-if="loading">
                        <v-card outlined>
                            <v-card-text class="text-center">
                                <v-progress-circular indeterminate color="primary"/>
                                <div>Cargando</div>
                            </v-card-text>
                        </v-card>
                    </template>
                    <template v-else>
                        <template v-if="list.length">
                            <v-card 
                                v-for="(group, indexJuego) of groupedList" :key="`resultado-list-group-index-${indexJuego}`"
                                outlined
                                class="mb-4"
                                >
                                <v-card-title class="font-weight-bold">
                                    <v-icon class="mr-2">mdi-cards</v-icon>
                                    {{ group.name }}
                                </v-card-title>
                                <v-divider/>
                                <v-card-text>
                                    <Item 
                                        v-for="(juegoResultado, indexResultado) of group.list" 
                                        :key="`resultado-list-group-item-${group.id}-index-${indexJuego}-list-item-${indexResultado}-${juegoResultado.id}`" 
                                        :juegoResultado="juegoResultado" 
                                        class="mb-2"
                                        />
                                </v-card-text>
                            </v-card>
                        </template>
                        <template v-else>
                            <v-card outlined>
                                <v-card-text class="d-flex justify-center">
                                    No hay resultados para la búsqueda
                                </v-card-text>
                            </v-card>
                        </template>
                    </template>
                </v-card-text>
            </v-card>
        </v-card-text>
        <JuegoResultadoModal :open.sync="isModalResultadoOpen" @saved="postSaved" data-backdrop="static"/>
    </v-card>
</template>
<script>
import ResultadoService from '@/services/operadora/resultados/ResultadoService';

import JuegoResultadoModal from'@components/entities/loteria/juego-resultado/modal-form';

import Search from './search';
import Item from './item';

export default {
    components: {
        Item,
        Search,
        JuegoResultadoModal
    },
    data: function () {
        return {
            grouping: 'horario',

            loading: false,
            list: [],
            isModalResultadoOpen: false,
            params: {
                is_anulado: false,
                fecha: this.$luxon.local().toISODate()
            }
        };
    },
    computed: {
        groupedList: function () {
            return this.$lodash.orderBy(this.list, [(item) => item.juego_sorteo.horario], ['desc']).reduce((groupedList, resultado) => {
                const groupIndex = groupedList.findIndex(group => group.id == (this.grouping == 'juego' ? resultado.juego_id : resultado.juego_sorteo.horario));
                if (groupIndex !== -1) {
                    const group = groupedList[groupIndex];
                    group.list.push(resultado);
                } else {
                    const group = {
                        list: [resultado]
                    };

                    if (this.grouping == 'juego') {
                        group['id'] = resultado.juego_id;
                        group['name'] = resultado.juego.name;
                    } else {
                        group['id'] = resultado.juego_sorteo.horario;
                        group['name'] = resultado.juego_sorteo.horario;
                    }

                    groupedList.push(group);
                }
                return groupedList;
            }, []);
        }
    },
    mounted: function () {
        this.fetchList();
    },
    methods: {
        fetchList: function (params = {}) {
            this.loading = true;
            this.list = [];
            ResultadoService.getList({...this.params, ...params})
                .then(({ juegoResultadoList }) => {
                    this.list = juegoResultadoList;
                }).finally(() => {
                    this.loading = false;
                });
        },
        openResultadoModal: function () {
            this.isModalResultadoOpen = true;
        },
        postSaved: function () {
            this.fetchList();
        },
    },
    watch: {
        params: function (params) {
            if (params.juego_id) this.grouping = 'juego';
            else this.grouping = 'horario';
            this.fetchList();
        },
    },
}
</script>